import axios from 'axios';
import { APISettings } from '../../config/ApiSettings';
import { unescape } from 'lodash';
// const baseUrl = APISettings.apiUrl;
const baseUrl = new APISettings().getApiURL();

class UserSubscriptionApi<UserSubscription> {
  // constructor() {}

  public getUserSubscriptions: (email: string) => Promise<UserSubscription> = async (
    email: string
  ) => {
    return (await axios.get(`${baseUrl}/UserSubscription/?emailAddress=${email}`)).data.output;
  };

  public createUserSubscription: (newSub: UserSubscription) => Promise<UserSubscription> = async (
    newSub: UserSubscription
  ) => {
    let response = (await axios.post(`${baseUrl}/UserSubscription`, newSub)).data.output;
    response.subscriptionUserId = btoa(unescape(response.encodedSubscriptionUserId));
    return response;
  }

  public removeUserSubscription: (subToRemove: UserSubscription) => Promise<UserSubscription> = async (
      subToRemove: UserSubscription
  ) => {
    return (await axios.delete(`${baseUrl}/UserSubscription`, {data: subToRemove})).data.output;
  }

  public removeAllUserSubscriptions: (subsToRemove: UserSubscription[]) => Promise<UserSubscription[]> = async (
      subsToRemove: UserSubscription[]
  ) => {
    return (await axios.delete(`${baseUrl}/UserSubscription/Range`, {data: subsToRemove})).data.output;
  }
}

export const userSubscriptionAPI = new UserSubscriptionApi();
